import React from 'react';

function ReportNavigation({ activeSection, savedCollegesCount, onScrollToSection }) {
  return (
    <div className="report-nav-tabs">
      <button
        onClick={() => onScrollToSection('profile-section')}
        className={`nav-tab ${activeSection === 'profile-section' ? 'active' : ''}`}
      >
        Profile
      </button>
      <button
        onClick={() => onScrollToSection('saved-colleges')}
        className={`nav-tab ${activeSection === 'saved-colleges' ? 'active' : ''}`}
      >
        My Saved Colleges ({savedCollegesCount})
      </button>
      <button
        onClick={() => onScrollToSection('reach-section')}
        className={`nav-tab ${activeSection === 'reach-section' ? 'active' : ''}`}
      >
        Reach
      </button>
      <button
        onClick={() => onScrollToSection('target-section')}
        className={`nav-tab ${activeSection === 'target-section' ? 'active' : ''}`}
      >
        Target
      </button>
      <button
        onClick={() => onScrollToSection('safety-section')}
        className={`nav-tab ${activeSection === 'safety-section' ? 'active' : ''}`}
      >
        Safety
      </button>
      <button
        onClick={() => onScrollToSection('next-steps-section')}
        className={`nav-tab ${activeSection === 'next-steps-section' ? 'active' : ''}`}
      >
        Next Steps
      </button>
    </div>
  );
}

export default ReportNavigation;